import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import InputText from "../components/InputText";
import Dropdown from "../components/Dropdown/Dropdown";
import Button from "../components/Button";
import BackHeader from "../components/Home/BackHeader";
import StepIndicator from "../components/Home/StepIndicator";
import rightIcon from "../assets/images/right-arrow.png";
import background from "../assets/images/Ubackground.png";
import heroPhysio from "../assets/images/hero_phy.png";
import { validateMobile, validatePinCode } from "../components/validations";
import { computeHoldAmount, saveHoldBookingDraft } from "../utils/holdBooking";
import { usePartner } from "../context/PartnerContext";

const cityOptions = ["Mumbai", "Pune", "Gurgaon", "New Delhi", "Noida"];
const painDurationOptions = ["<2 weeks", "2-6 weeks", "6 weeks-6 months", ">6 months"];

const OpsHoldForm = () => {
  const navigate = useNavigate();
  const { partnerSlug } = useParams();
  const { config } = usePartner() || {};
  const [warnings, setWarnings] = useState({ mobile: "", pinCode: "" });
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);
  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    city: "Mumbai",
    pinCode: "",
    pain_condition: "",
    pain_score: 0,
    pain_duration: "",
  });

  useEffect(() => {
    const filled =
      formData.user_name.trim() !== "" &&
      formData.user_phone.trim() !== "" &&
      formData.city.trim() !== "" &&
      formData.pinCode.trim() !== "" &&
      !warnings.mobile &&
      !warnings.pinCode;
    setAllFieldsFilled(filled);
  }, [formData, warnings]);

  const handleInputChange = (name, value) => {
    const nextWarnings = { ...warnings };
    if (name === "user_phone") nextWarnings.mobile = validateMobile(value);
    if (name === "pinCode") nextWarnings.pinCode = validatePinCode(value);

    setWarnings(nextWarnings);
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!allFieldsFilled) return;

    const amount = computeHoldAmount(formData.city, config, partnerSlug);
    saveHoldBookingDraft({
      name: formData.user_name,
      phone: formData.user_phone,
      address: formData.city,
      pinCode: formData.pinCode,
      pain_condition: formData.pain_condition,
      pain_score: Number(formData.pain_score) || 0,
      pain_duration: formData.pain_duration,
      amount,
    });

    navigate("/ops/hold-booking/slots");
  };

  return (
    <div className="relative min-h-screen w-full overflow-x-hidden bg-white">
      <div className="relative z-10 flex flex-col justify-start items-center w-full mt-0 mb-0 md:mt-5 md:mb-10">
        <div className="w-full max-w-[700px] rounded-2xl shadow-lg bg-cover bg-no-repeat">
          <BackHeader onBack={() => navigate(-1)} />
          <StepIndicator step={1} totalSteps={3} header="Patient Details" />
          <img
            src={heroPhysio}
            className="w-full rounded-2xl mt-3"
            alt="hold booking hero"
          />
          <div
            className="w-full"
            style={{
              backgroundImage: `url(${background})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "0 0 30px 30px",
            }}
          >
            <form className="w-full flex justify-center bg-transparent px-4" onSubmit={handleSubmit}>
              <div className="w-full max-w-[768px]">
                <div className="form_wrapper pt-10">
                  <InputText
                    name="user_name"
                    label="Patient Name"
                    placeholder="Enter patient name"
                    value={formData.user_name}
                    onChange={(event) => handleInputChange("user_name", event.target.value)}
                  />
                  <InputText
                    name="user_phone"
                    warnings={warnings.mobile}
                    label="Mobile Number"
                    placeholder="Enter patient mobile number"
                    value={formData.user_phone}
                    onChange={(event) => handleInputChange("user_phone", event.target.value)}
                  />
                  <Dropdown
                    label="City"
                    value={formData.city}
                    data={cityOptions}
                    callback={(value) => handleInputChange("city", value)}
                  />
                  <InputText
                    name="pinCode"
                    warnings={warnings.pinCode}
                    label="Pin Code"
                    placeholder="Enter patient pin code"
                    value={formData.pinCode}
                    onChange={(event) => handleInputChange("pinCode", event.target.value)}
                  />
                  <InputText
                    name="pain_condition"
                    label="Pain Condition"
                    placeholder="Describe the pain condition"
                    value={formData.pain_condition}
                    onChange={(event) => handleInputChange("pain_condition", event.target.value)}
                  />
                  <Dropdown
                    label="How long has the patient had this pain?"
                    value={formData.pain_duration}
                    data={painDurationOptions}
                    callback={(value) => handleInputChange("pain_duration", value)}
                  />

                  <div
                    style={{
                      marginBottom: "10px",
                      marginTop: "30px",
                      boxSizing: "border-box",
                      marginLeft: "16px",
                      marginRight: "16px",
                      width: "90%",
                      padding: "18px",
                      background: "#FFF",
                      borderRadius: "12px",
                      border: "1px solid #E5E7EB",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "14px",
                        color: "black",
                        fontWeight: "600",
                        display: "block",
                        textAlign: "left",
                        paddingLeft: "4px",
                      }}
                    >
                      Rate current pain on 0 to 10
                    </label>

                    <div style={{ textAlign: "center", marginBottom: "0px" }}>
                      <div
                        style={{
                          fontSize: "26px",
                          fontWeight: "700",
                          color: "var(--partner-primary)",
                        }}
                      >
                        {formData.pain_score}
                      </div>
                    </div>

                    <style>
                      {`
                        .ops-hold-pain-slider {
                          -webkit-appearance: none;
                          width: 100%;
                          height: 6px;
                          border-radius: 4px;
                          background: linear-gradient(to right, var(--partner-primary) ${formData.pain_score * 10}%, #ccc ${formData.pain_score * 10}%);
                          outline: none;
                        }
                        .ops-hold-pain-slider::-webkit-slider-thumb {
                          -webkit-appearance: none;
                          appearance: none;
                          width: 18px;
                          height: 18px;
                          border-radius: 50%;
                          background: var(--partner-primary);
                          cursor: pointer;
                          border: none;
                          box-shadow: 0 0 4px rgba(0,0,0,0.3);
                        }
                        .ops-hold-pain-slider::-moz-range-thumb {
                          width: 18px;
                          height: 18px;
                          border-radius: 50%;
                          background: var(--partner-primary);
                          cursor: pointer;
                          border: none;
                          box-shadow: 0 0 4px rgba(0,0,0,0.3);
                        }
                      `}
                    </style>

                    <input
                      type="range"
                      name="pain_score"
                      min="0"
                      max="10"
                      value={formData.pain_score}
                      onChange={(event) => handleInputChange("pain_score", event.target.value)}
                      className="ops-hold-pain-slider"
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "13px",
                        color: "#6B7280",
                      }}
                    >
                      <span>No Pain</span>
                      <span>Worst Pain</span>
                    </div>
                  </div>

                  <div className="flex justify-center mt-8">
                    <Button
                      btnName={
                        <span className="flex items-center gap-2">
                          Continue To Slots
                          <img
                            src={rightIcon}
                            alt="arrow"
                            className="w-6 h-5 invert brightness-0"
                          />
                        </span>
                      }
                      style={{
                        backgroundColor: "var(--partner-primary)",
                        color: "#FFFFFF",
                        fontWeight: 600,
                        fontSize: "18px",
                        textAlign: "center",
                        padding: "10px 40px",
                        borderRadius: "12px",
                        margin: "16px 0",
                        opacity: allFieldsFilled ? 1 : 0.5,
                        cursor: allFieldsFilled ? "pointer" : "not-allowed",
                      }}
                      disabled={!allFieldsFilled}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpsHoldForm;
